import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { ClipboardList, Eye, Trash2 } from 'lucide-react';

const formatDate = (dateStr) => {
  if (!dateStr) return '-';
  const date = new Date(dateStr);
  return date.toLocaleDateString('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
};

export const InterventionsTable = ({ interventions, onDelete }) => (
  <div className="bg-[#121212] border border-[#27272A]">
    <div className="p-6 border-b border-[#27272A]">
      <h3 className="text-xl font-semibold uppercase" style={{ fontFamily: "'Barlow Condensed', sans-serif" }}>
        Elenco Interventi
      </h3>
    </div>

    {interventions.length === 0 ? (
      <div className="p-12 text-center">
        <ClipboardList className="w-12 h-12 text-[#27272A] mx-auto mb-4" />
        <p className="text-[#A1A1AA]">Nessun intervento registrato</p>
        <Link to="/intervention/new">
          <Button className="mt-4 bg-[#E3000F] text-white rounded-none uppercase tracking-wide" data-testid="first-intervention-btn">
            Crea il primo intervento
          </Button>
        </Link>
      </div>
    ) : (
      <div className="overflow-x-auto">
        <table className="intervention-table">
          <thead>
            <tr>
              <th>N. Intervento</th>
              <th>Tipo</th>
              <th>Indirizzo</th>
              <th>Data</th>
              <th>Stato VVF</th>
              <th>Azioni</th>
            </tr>
          </thead>
          <tbody>
            {interventions.map((intervention) => (
              <tr key={intervention.id} data-testid={`intervention-row-${intervention.id}`}>
                <td>
                  <span className="font-mono text-[#E3000F] font-medium">#{intervention.numero_intervento}</span>
                </td>
                <td className="text-white">{intervention.tipo_intervento}</td>
                <td className="text-[#A1A1AA] max-w-[200px] truncate">{intervention.indirizzo}</td>
                <td className="text-[#71717A] font-mono text-sm">{formatDate(intervention.data_intervento || intervention.created_at)}</td>
                <td>
                  {intervention.caricato_portale_vvf ? (
                    <span className="badge-success px-2 py-1 text-xs font-mono uppercase">Caricato</span>
                  ) : (
                    <span className="badge-warning px-2 py-1 text-xs font-mono uppercase">Da caricare</span>
                  )}
                </td>
                <td>
                  <div className="flex items-center gap-2">
                    <Link to={`/intervention/${intervention.id}`}>
                      <Button variant="ghost" size="icon" className="text-[#A1A1AA] hover:text-white hover:bg-[#1A1A1A]" data-testid={`view-intervention-${intervention.id}`}>
                        <Eye className="w-4 h-4" />
                      </Button>
                    </Link>
                    <Button
                      variant="ghost"
                      size="icon"
                      className="text-[#A1A1AA] hover:text-[#EF4444] hover:bg-[#EF4444]/10"
                      onClick={() => onDelete(intervention.id)}
                      data-testid={`delete-intervention-${intervention.id}`}
                    >
                      <Trash2 className="w-4 h-4" />
                    </Button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )}
  </div>
);
